<template>
  <div class="neibianj">
    <el-row class=" mab_20" type="flex" :gutter="20">
      <el-col :span="24">
        <div class="filter-inline-panel cle">
          <el-form :inline="true" size="mini" :model="filterForm" class="filter-panel">
          	<el-form-item label="名称" prop="keyword">
	            <el-input v-model="filterForm.keyword" @keyup.enter="company_chaxun" auto-complete="off"></el-input>
	          </el-form-item>
          	<el-form-item>
	            <el-button type="primary" size="mini" @click="company_chaxun">搜索</el-button>
          	</el-form-item>
          </el-form>
          <div class="list-opinion fr">
            <el-button type="primary" v-if="hasBtn('btn_add')" size="mini" @click="articleEdit()">新建</el-button>
          </div>
        </div>
        <el-table :data="list" size="mini" v-if="list" border>
          <el-table-column prop="name" align="center" label="名称"></el-table-column>
          <el-table-column prop="sort" align="center" label="排序"></el-table-column>
          <el-table-column prop="sort" align="center" label="所属片区">
          	<template slot-scope="scope">
          		{{scope.row.area_id | area_f(that)}}
          	</template>
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="articleEdit(scope.row)">编辑</el-button>
              <el-button size="mini" type="info" @click="articleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-row class="tree-content" type="flex" :gutter="20">
      <el-col :span="24" class="page-pagination">
        <el-pagination style="float:right;" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pagerCount="5"></el-pagination>
      </el-col>
    </el-row>
    <el-dialog title="编辑" width="500px" :visible="editFormVisible" @close="editFormVisible = false">
      <el-form :model="editForm" label-position="top" size="mini" :rules="editFormRules" ref="editForm">
        <el-row class="tree-content w100" :gutter="20">
          <el-col :span="24">
            <el-form-item label="所属片区" prop="area_id">
              <el-select v-model="editForm.area_id" class="w100" placeholder="请选择">
                <el-option v-for="(item,index) in area_data" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="名称" prop="name">
              <el-input v-model="editForm.name" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="排序" prop="sort">
              <el-input v-model="editForm.sort"  auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" size="mini" @click.native="articleAction('editForm')">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import EditorBar from '../../components/wangEnduit.vue'
import global   from  '../../global.vue'
export default {
	name: '',
	components: {
		EditorBar
	},
	data() {
		return {
			that: this,
			http:global.http,
			isClear: false,
			editForm: {
				name:'',
				sort:'',
				area_id:'',
			},
			editFormRules: {
				area_id: [{
					required: true,
					message: '请选择所属片区',
					trigger: 'change'
				}],
				name: [{
					required: true,
					message: '请输入名称',
					trigger: 'blur'
				}],
			},
			editFormVisible: false,
			filterForm: {
				keyword:'',
			},
			list: [],
			pages: {
				page: 1,
				count: 100,
				perpage: 10,
			},
			area_data:[],
		};
	},
	// 初始事件
	mounted: function () {
		this.config();
	},
	methods: {
		config() {
			var this_ = this;
			var url = "areaOption";
			var datas = {
			}
			this_.$post(url, datas).then((res) => {
				this_.area_data = res;
				this_.init();
			})
		},
		init() {
			var this_ = this;
			var url = "areaBlockList";
			var datas = {
				page: this_.pages.page,
				num: this_.pages.perpage,
				keyword:this_.filterForm.keyword,
			}
			this_.$post(url, datas).then((res) => {
				this_.list = res.list;
				this_.pages.count = res.sum;
			})
		},
		// 搜索
		company_chaxun() {
			var this_ = this;
			var pages = this_.pages;
			pages['page'] = 1;
			this_.pages = pages;
			this_.init();
		},
		articleDelete(index, data) {
			var this_ = this;
			var url = "areaBlockDelete";
			var datas = {
				id: data.id
			}
			this_.$confirm('确认删除吗?', '提示', {
				//type: 'warning'
			}).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success('删除成功');
					this_.init();
				})
			}).catch(() => {});
		},
		articleEdit(e) {
			if (e) {
				this.editForm = e;
			} else {
				this.editForm = {
					name:'',
					sort:'',
					area_id:'',
				}
			}
			this.editFormVisible = true;
		},
		// 保存
		articleAction(editForm) {
			var this_ = this;
			this_.$refs[editForm].validate((valid) => {
				if (valid) {
					var url = "areaBlockAction";
					var datas = {
						name: this_.editForm.name,
						sort: this_.editForm.sort,
						area_id: this_.editForm.area_id,
					}
					var tishi = '添加成功';
					if (this_.editForm.id) {
						datas['id'] = this_.editForm.id;
						tishi = '修改成功';
					}
					this_.$post(url, datas).then((res) => {
						this_.$message.success(tishi);
						this_.editFormVisible = false;
						this_.init();
					});
				} else {
					return false;
				}
			})
		},
		// 图片上传
		imageSuccess(res, file) {
			if (res.status == 200) {
				this.editForm.image = res.data.showname;
				this.editForm.image_ry = res.data.savename;
			} else {
				his_.$message.success(res.message);
			}
		},


		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		}
	},
    filters: {
    	area_f(v,that){
    		var fanhui='';
    		if (v) {
	    		var area_data=that.area_data;
	    		for (var i = 0; i < area_data.length; i++) {
	    			if (area_data[i].id==v) {
						fanhui=area_data[i].name
	    			}
	    		}
    		}else{
    			fanhui=v;
    		}
    		return fanhui
    	},
    },
}
</script>
<style scoped>
.neibianj {
	padding: 1px;
}
.filter-inline-panel {
	margin-bottom: 10px;
}

</style>
<style type="text/css">
.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}
.avatar-uploader .el-upload:hover {
	border-color: #409EFF;
}
.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 100px;
	height: 100px;
	line-height: 100px;
	text-align: center;
}
.avatar {
	width: 100px;
	height: 100px;
	display: block;
}
.filter-panel{
	width: 80%;
	float: left;
}
</style>


// WEBPACK FOOTER //
// src/views/data/massif.vue